module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header"
  }, [(_vm.isShow) ? _c('XHeader', {
    attrs: {
      "left-options": {
        showBack: _vm.showBack,
        backText: '',
        preventGoBack: _vm.$route.name === 'reportHistory'
      }
    },
    on: {
      "on-click-back": _vm.handleBack
    }
  }, [_c('div', {
    staticClass: "app-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showPayRecord) ? _c('router-link', {
    directives: [{
      name: "stat",
      rawName: "v-stat",
      value: ({
        id: _vm.text === '历次考试' ? (_vm.userInfo.roleType === 1 ? 'wxfwh_xs_bglb_zxksbg_lcks_click' : 'wxfwh_jz_bglb_zxksbg_lcks_click') : ''
      }),
      expression: "{id:text === '历次考试'?(userInfo.roleType ===1? 'wxfwh_xs_bglb_zxksbg_lcks_click':'wxfwh_jz_bglb_zxksbg_lcks_click'):''}"
    }],
    style: (_vm.rightSlotStyle),
    attrs: {
      "to": {
        name: _vm.toName
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5d4d60e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ReportApp/components/AppHeader.vue
// module id = 309
// module chunks = 169